import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui-color',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiColorComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <input
      type="color"
      [id]="id"
      [attr.name]="name"
      [value]="modelValue"
      (input)="onInputEvent($event)"
      (change)="change.emit($event)"
      (blur)="onBlurEvent()"
      [disabled]="disabled || disabledByForm"
      [class]="colorClass"
      [attr.aria-label]="ariaLabel"
    />
  `,
})
export class UiColorComponent implements ControlValueAccessor {
  @Input() id?: string;
  @Input() name?: string;
  @Input() value?: string;
  @Input() disabled = false;
  @Input() ariaLabel?: string;
  @Input() colorClass = 'w-9 h-9 rounded border border-gray-300 cursor-pointer p-0.5 bg-white';
  @Input() formControl?: FormControl;
  @Input() ngModel?: any;

  @Output() ngModelChange = new EventEmitter<any>();
  @Output() input = new EventEmitter<Event>();
  @Output() change = new EventEmitter<Event>();

  modelValue = '#000000';
  disabledByForm = false;
  private onChangeFn: (value: any) => void = () => {};
  private onTouchedFn: () => void = () => {};

  writeValue(value: any): void {
    this.modelValue = value ?? '#000000';
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledByForm = isDisabled;
  }

  onInputEvent(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.modelValue = value;
    this.ngModelChange.emit(value);
    this.onChangeFn(value);
    this.input.emit(event);
  }

  onBlurEvent(): void {
    this.onTouchedFn();
  }
}
